import React, { Component } from 'react';

import Tooltip from '../../components/tooltip';

class ResourceDelete extends Component {
  propTypes: {
    resourceId: React.PropTypes.string.isRequired,
    resourceType: React.PropTypes.string.isRequired,
    onSuccess: React.PropTypes.func,
    visible: React.PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    let className = '';
    if (!this.props.visible) {
      className += 'no-vis';
    }

    this.state = {
      resourceId: this.props.resourceId,
      resourceType: this.props.resourceType,
      wrapperClassName: className,
    };
  }

  onClick(e) {
    e.preventDefault();
    e.resourceDeleteEvent = true;
    const authToken = localStorage.getItem('id_token');
    this.deleteResource(
      authToken,
      this.state.resourceId,
      this.state.resourceType,
    );
  }

  render() {
    const removeButton = (
      <div className={this.state.wrapperClassName}>
        <button className="small rose top-right" onClick={this.onClick.bind(this)}>
          <img className="image budget-patch" src="/icons/cross.svg" />
        </button>
      </div>
    );

    if (this.props.visible) {
      return (
        <Tooltip content="Remove Item?" style="frame">
          {removeButton}
        </Tooltip>
      );
    }

    return removeButton;
  }

  /* SUPPORT FUNCTIONS */

  deleteResource(authToken, resourceId, resourceType) {
    const options = this.getResourceDeleteOptions(
      authToken,
      resourceId,
      resourceType,
    );
  }

  getResourceDeleteOptions(authToken, resourceId, resourceType) {
    return {
      method: 'DELETE',
      url: `${process.env.REACT_APP_API_BASE_URL}/${resourceType}/${resourceId}`,
      headers: {
        authorization: `Bearer ${authToken}`,
        'content-type': 'application/json',
      },
      json: true,
    };
  }
}

export default ResourceDelete;



/** WEBPACK FOOTER **
 ** ./src/containers/resource-delete/index.js
 **/